import { Button, H5, P, UniversalLink } from "@template/components";
import * as S from "./styles.ts";

export const Webinar = () => {
  return (
    <S.WebinarContainer>
      <div>
        <P>New to Cloud Telephony?</P>
        <H5>Join one of our free live webinars!</H5>
        <P $small={true}>
          Join one of our twice weekly webinars for a guided tour of our
          business phone system and features.
        </P>
      </div>
      <UniversalLink
        href="https://yay.com/webinar"
        title="Link to webinar"
      >
        <Button
          size="md"
          variant="solid"
        >
          Find Out More!
        </Button>
      </UniversalLink>
    </S.WebinarContainer>
  );
};
